module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard-section m-t-lg m-b-lg"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-invoice"
  }, [_vm._l((_vm.invoices), function(invoice) {
    return _c('invoice-item', {
      key: invoice.id,
      attrs: {
        "invoice": invoice
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoInvoices),
      expression: "haveNoInvoices"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("No invoices found.")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'invoices.index'
      }
    }
  }, [_vm._v("View All Invoices")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "far fa-file-invoice"
  }), _vm._v(" Invoices")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-46f7679e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/InvoiceList.vue
// module id = 986
// module chunks = 0